import { FC, Suspense, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Outlet, useLocation } from "react-router-dom";

import ScreenLoader from "components/ScreenLoader/ScreenLoader";
import { Providers } from "config/init/providers";
import { ModalsProvider } from "config/init/providers/ModalsProvider";
import Footer from "containers/Footer/Footer";
import Header from "containers/Header/Header";
import { usePageTitle } from "modules/hooks/usePageTitle";
import { SharedBlocker } from "modules/hooks/usePrompt";
import { useAppDispatch } from "store";
import { locationChange } from "store/actions/router";

const RootLayout: FC = () => {
  const pageTitle = usePageTitle();
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      locationChange({
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
      })
    );
  }, [location, dispatch]);

  return (
    // Providers are rendered inside RootLayout (the stable root route element) rather than
    // above the router. RootLayout only unmounts if the entire router is destroyed, so
    // provider re-mount is not a concern for normal navigation. This placement allows
    // providers to access router context (useNavigate, useLocation, etc.) if needed.
    <Providers>
      <Helmet>
        <title>{pageTitle}</title>
        <meta
          name="description"
          content="Term life insurance tailored to you because you choose what's in it. With flexible coverage, 100% online process, instant coverage, and over-the-top customer support, we make Wyshes come true. Starting at $9/mo."
        />
      </Helmet>
      <SharedBlocker />
      <ModalsProvider />
      <div className="App">
        <Header />
        <div className="App-content__container">
          <Suspense fallback={<ScreenLoader />}>
            <Outlet />
          </Suspense>
        </div>
        <Footer />
      </div>
    </Providers>
  );
};

export default RootLayout;
